/* eslint-disable  consistent-return */
import { isMobile } from '../../../../utils';

import './style.scss';

const mobilePricingInit = () => {
  const priceTable = document.querySelector('.PriceTable');

  if (!priceTable) return;

  const select = priceTable.querySelector('[data-pricing-select]');
  const tabs = priceTable.querySelectorAll('[data-pricing-level]');

  const main = () => {
    const state = {
      current: 0,
    };

    const changeHandler = () => {
      tabs[state.current].style.display = 'none';
      tabs[select.value].style.display = 'block';
      state.current = select.value;
    };

    if (isMobile) {
      select.value = 0;
      select.addEventListener('change', changeHandler, false);
    } else {
      select.removeEventListener('change', changeHandler, false);

      [].slice.call(tabs).forEach(item => {
        item.style.display = ''; // eslint-disable-line
      });
    }
  };

  main();
  window.addEventListener('orientationchange', main, false);
};

export default mobilePricingInit;
